<template>
  <div class="home">
    <div class="container">
      <div class="row">
        <div class="col-12 mt-4">
          <welcome />
        </div>
        <div class="col-12 col-sm-6 mt-4">
          <telegram />
        </div>
        <div class="col-12 col-sm-6 mt-4">
          <testing />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import welcome from "./home-cards/welcome-card.vue";
import telegram from "./home-cards/telegram-card.vue";
import testing from "./home-cards/testing-card.vue";
export default {
  components: {
    welcome,
    telegram,
    testing,
  },
};
</script>

<style lang="scss" scoped></style>
